<template>
  <w-button
    fluid
    class="form-aside-button"
    radius="square"
    text-align="left"
    size="sm"
    variant="ghost"
    :class="active ? 'form-aside-button--active' : undefined"
    @click="$emit('tabSelected', tab.name)"
  >
    <w-flex fluid class="form-aside-button__content">
      <w-flex class="form-aside-button__number"> {{ index + 1 }}.</w-flex>

      <w-flex class="form-aside-button__title"> {{ tab.title }} </w-flex>
    </w-flex>
  </w-button>
</template>

<script setup lang="ts">
import type { Tab } from '@/typings/tab';

defineProps<{
  index: number;
  tab: Tab;
  active: boolean;
}>();
</script>

<style lang="scss">
.form-aside-button {
  padding-left: 4px;
  padding-right: 4px;
  color: w.color('neutral', 200);

  &__number,
  &__title {
    transition: w.transition('x-fast') w.ease('out-expo');
  }

  &--active {
    color: w.color('neutral', 100);

    .form-aside-button {
      &__title {
        text-decoration: underline;
        text-decoration-color: w.color('neutral', 200);
        text-underline-offset: 4px;
      }
    }
  }

  &__number {
    min-width: 24px;
  }
}
</style>
